<template>
    <tr>
        <!-- First TD -->
        <td v-if="!updatingData && !updatingCodes">
            <span v-if="member.lastName != null">
                {{ member.lastName }}
            </span>
            <span v-else class="text-black-50 fst-italic">
                Non renseigné
            </span>
        </td>
        <td v-else-if="!updatingCodes">
            <input v-model="newLastName" type="text" class="form-control" placeholder="Nouveau nom">
        </td>
        <td v-if="updatingCodes">
            <input v-model="newVerificationCode" type="text" class="form-control"
                placeholder="Nouveau code de vérification">
        </td>
        <!-- Second TD -->
        <td v-if="!updatingData && !updatingCodes">
            <span v-if="member.firstName != null">
                {{ member.firstName }}
            </span>
            <span v-else class="text-black-50 fst-italic">
                Non renseigné
            </span>
        </td>
        <td v-else-if="!updatingCodes">
            <input v-model="newFirstName" type="text" class="form-control" placeholder="Nouveau prénom">
        </td>
        <td v-if="updatingCodes">
            <input v-model="newAlertCode" type="text" class="form-control" placeholder="Nouveau code sous contrainte">
        </td>
        <!-- Third TD -->
        <template v-if="$isAdmin">
            <td v-if="!updatingData && !updatingCodes && !this.isViewer" class="text-end">
                <div class="me-4">
                    <a data-bs-toggle="dropdown" href="#" class="btn p-1" aria-expanded="false">
                        <font-awesome-icon :icon="['fas', 'bars']" />
                    </a>
                    <div class="dropdown-menu dropdown-menu-end" style="">
                        <a role="button" v-on:click="updatingData = true" class="dropdown-item">Modifier</a>
                        <a role="button" v-on:click="updatingCodes = true" class="dropdown-item">Changer codes</a>
                    </div>
                </div>
            </td>
            <td v-else class="text-end">
                <ButtonDisplay :type="'save'" @click="save" />
                <ButtonDisplay :type="'cancel'" @click="updatingData = false; updatingCodes = false" />
            </td>
        </template>
    </tr>
</template>

<script>
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'

export default {
    props: ['member'],
    components: {
        ButtonDisplay
    },
    data() {
        return {
            updatingData: false,
            updatingCodes: false,
            newFirstName: null,
            newLastName: null,
            newVerificationCode: null,
            newAlertCode: null,
        };
    },
    mounted() {
        this.newFirstName = this.member.firstName;
        this.newLastName = this.member.lastName;
    },
    methods: {
        save() {
            // Mode "Changer codes" → n'envoyer QUE les champs non vides
            if (this.updatingCodes) {
                const payload = {};
                const verif = (this.newVerificationCode || '').trim();
                const alertC = (this.newAlertCode || '').trim();
                if (verif) payload.verificationCode = verif;
                if (alertC) payload.alertCode = alertC;

                if (Object.keys(payload).length === 0) {
                    // Rien de saisi → on reste en mode édition des codes
                    alert("Renseignez le ou les codes avant d'enregistrer.");
                    return;
                }
                this.$emit("save", payload);
                // On ferme l'édition seulement si on a bien émis quelque chose
                this.updatingCodes = false;
                this.updatingData = false;
                // (optionnel) on reset les champs de saisie des codes
                this.newVerificationCode = null;
                this.newAlertCode = null;
                return;
            }

            // Mode "Modifier" (nom/prénom)
            this.$emit("save", { firstName: this.newFirstName, lastName: this.newLastName });
            this.updatingData = false;
            this.updatingCodes = false;
        },
    }
}
</script>